import { createContext, useState, useRef, useEffect } from "react";

export const NavContext = createContext();

// Custom debounce function
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
      timeoutId = null; // Clear the timeoutId after function execution
    }, delay);
  };
};

export const NavProvider = ({ children }) => {
  const [menuState, setMenuState] = useState({
    initial: true,
    clicked: false,
    menuName: "Menu",
    menuOpen: false,
  });
  const [isNavDisabled, setIsNavDisabled] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutIdRef = useRef(null);

  const clearTimer = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      console.log(
        "NavContext - clearTimer() timeoutIdRef.current:",
        timeoutIdRef.current
      );
    }
  };

  const handleNav = debounce(() => {
    console.log("NavContext - handleNav()", menuState);
    if (!isNavDisabled) {
      clearTimer(); // Clear any existing timers
      if (menuState.clicked && menuState.menuOpen) {
        document.body.style.overflow = "auto"; // Enable scrolling on the body
      } else if (!menuState.clicked && !menuState.menuOpen) {
        document.body.style.overflow = "hidden"; // Disable scrolling on the body
      }
      setMenuState({
        initial: null,
        clicked: !menuState.clicked,
        menuName: menuState.clicked ? "Menu" : "Close",
        menuOpen: !menuState.menuOpen,
      });
      setIsNavDisabled(true);
      setIsAnimating(true);
      timeoutIdRef.current = setTimeout(() => {
        setIsNavDisabled(false);
        setIsAnimating(false);
        console.log(
          "NavContext - handleNav(() => { timeoutIdRef.current setTimeout:",
          timeoutIdRef.current,
          "})"
        );
      }, 1000); // Set your desired timeout in milliseconds
    }
  }, 300);

  const closeNav = debounce(() => {
    console.log("NavContext - closeNav()", menuState);
    if (!isNavDisabled) {
      clearTimer(); // Clear any existing timers
      if (menuState.menuOpen) {
        setMenuState({
          clicked: false,
          menuName: "Menu",
          menuOpen: false,
        });
        document.body.style.overflow = "auto"; // Enable scrolling on the body
      }
      setIsNavDisabled(true);
      setIsAnimating(true);
      timeoutIdRef.current = setTimeout(() => {
        setIsNavDisabled(false);
        setIsAnimating(false);
        console.log(
          "NavContext - closeeNav(() => { timeoutIdRef.current setTimeout:",
          timeoutIdRef.current,
          "})"
        );
      }, 1000); // Set your desired timeout in milliseconds
    }
  }, 300);

  useEffect(() => {
    // Cleanup function when the component unmounts or when debounce functions are re-invoked
    return clearTimer;
  }, []);

  console.log("NavContext component rendered");

  return (
    <NavContext.Provider
      value={{
        menuState,
        setMenuState,
        handleNav,
        closeNav,
        isNavDisabled,
        setIsNavDisabled,
        debounce,
        // stopButtonSpam,
        isAnimating,
        setIsAnimating,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};
